import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './styles/navbar.css';
import logo from '../logo.png';

function NavigationBar() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close the menu whenever a nav link is clicked
  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      className="nav-main"
      expand="lg"
      fixed="top"
    >
      <Container className={`d-flex justify-content-between align-items-center ${scrolled ? 'nav-container-scrolled' : ''}`}>
        <Navbar.Brand as={Link} to="/" onClick={handleNavClick}>
          <img src={logo} alt="Webpop Logo" className="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavClick}>Home</Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={handleNavClick}>About</Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavClick}>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
